import { render, staticRenderFns } from "./DataRow.vue?vue&type=template&id=625f07c7&"
import script from "./DataRow.vue?vue&type=script&lang=js&"
export * from "./DataRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/musili/musilidev/webroot/work-bmm/01_DEX/dex/front-end/web-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('625f07c7')) {
      api.createRecord('625f07c7', component.options)
    } else {
      api.reload('625f07c7', component.options)
    }
    module.hot.accept("./DataRow.vue?vue&type=template&id=625f07c7&", function () {
      api.rerender('625f07c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenant/views/Dashboard/Components/DataRow.vue"
export default component.exports